import React from 'react';
import { Link } from 'react-router-dom';

import { slugify } from '../../../utils/slugify';

function GolfTripTableRow({
  course,
  day,
  selectedCountrySearch,
  countryRankPrefix,
}) {
  const countryMapping = {
    England: 'england',
    Scotland: 'scotland',
    Ireland: 'ireland',
    'Northern Ireland': 'ni',
    Wales: 'wales',
    USA: 'usa',
  };
  const mappedPrefix = countryMapping[course.course_country] || '';
  const distanceInKm = (course.distance / 1000).toFixed(0); // Convert distance to km and format it to two decimal places
  // Logic remains the same as the Larger Screens section in GolfTripLine

  const getGreenFeesRange = (greenFees) => {
    const propertiesToCheck = [
      'high_weekday',
      'high_weekday_twighlight',
      'high_weekend',
      'high_weekend_twighlight',
      'low_weekday',
      'low_weekday_twighlight',
      'low_weekend',
      'low_weekend_twighlight',
    ];

    const feeValues = propertiesToCheck
      .map((prop) => greenFees[prop])
      .filter(Boolean);

    if (feeValues.length === 0) return 'No Data';

    const minFee = Math.min(...feeValues);
    const maxFee = Math.max(...feeValues);

    return minFee === maxFee ? `£${maxFee}` : `£${minFee} - £${maxFee}`;
  };

  return (
    <tr className="hidden md:table-row border-b-2 border-gray-300 py-2">
      <td className="text-gray-800 text-sm xl:text-base">{`Day ${day}`}</td>
      <td className="text-gray-800 text-sm xl:text-base">
        {course.course_name ? (
          <Link
            to={`/lists/golf-courses/${slugify(course.course_name)}`}
            className="text-indigo-600 hover:text-indigo-800 hover:underline"
          >
            {course.course_name}
          </Link>
        ) : (
          course.course_name
        )}
      </td>
      {course.distance !== undefined && course.distance !== null && (
        <td className="text-gray-800 text-sm xl:text-base">
          {distanceInKm} km
        </td>
      )}

      <td className="text-gray-800 text-sm xl:text-base">
        {course.course_county ? (
          <Link
            to={`/lists/golf-courses/county-ranking/${slugify(
              course.course_county,
            )}`}
            className="text-indigo-600 hover:text-indigo-800 hover:underline"
          >
            {course.course_county}
          </Link>
        ) : (
          course.course_county
        )}
      </td>
      <td className="text-gray-800 text-sm xl:text-base">
        {course[`${mappedPrefix}_rank_gl`]}
      </td>
      <td className="text-gray-800 text-sm xl:text-base">
        {course.county_rank}
      </td>
      <td className="text-gray-800 text-sm xl:text-base">
        {course.course_style ? course.course_style : 'No Style Data'}
      </td>
      <td className="text-green-700 text-sm xl:text-base">
        {getGreenFeesRange(course.green_fees)}
      </td>
    </tr>
  );
}

export default GolfTripTableRow;
